import { Emitter, Event } from "../../../../../features/event-emitter"
import { useAdministrationHooks, useAdministrationState } from "../../../hooks/administrationHooks"
import { Data2 } from "../../../../../features/data-types"
import { useExpenseService } from "../../../services/expenseService"
import { TicketType } from "../../../state/types"

export const useActions = () => {
    const { currentEmployee } = useAdministrationState()

    const { getSalaryExpenseTypeId } = useAdministrationHooks()

    const { createExpense, updateExpense } = useExpenseService()

    const submitExpense = async (
        data: Data2,
        branchId: string,
        createMode: boolean,
        detail?: string,
        ticketFile?: File
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        const { id, name, amount, paymentDate } = data
        if (createMode) {
            const expenseData = {
                name,
                expenseTypeId: getSalaryExpenseTypeId(),
                branchId,
                amount,
                detail,
                employeeId: currentEmployee!.id,
            }
            const ticketData = {
                type: TicketType.SALARY,
                dueDate: paymentDate,
                subtotal: amount,
                vatAmount: 0,
                total: amount,
                ticketFile
            }
            await createExpense(expenseData, ticketData)
        } else {
            const expenseData = {
                id,
                name,
                amount,
                detail
            }
            const ticketData = {
                dueDate: paymentDate,
                subtotal: amount,
                total: amount,
                ticketFile
            }
            await updateExpense(expenseData, ticketData)
        }

        Emitter.emit(Event.DB_SUBMIT_DONE, true)
    }
    
    return {
        submitExpense
    }
}
